module.exports = __webpack_public_path__ + "img/Sent-Message-bro.2f3e9bac.png";